import Axios from "axios";
import {
  SET_TRIAL_BALANCE_REPORT,
  UNSET_TRIAL_BALANCE_REPORT,
} from "@/store/mutation-types";
import {
  getTrialBalanceReport,
} from "@/store/api";

const state = {
  trialBalanceReport: [],
};

const getters = {
  getTrialBalanceReport(state) {
    return state.trialBalanceReport;
  },
};

const mutations = {
  [SET_TRIAL_BALANCE_REPORT](state, data) {
    state.trialBalanceReport = data;
  },
  [UNSET_TRIAL_BALANCE_REPORT](state) {
    state.trialBalanceReport = [];
  },
};

const actions = {
  getTrialBalance({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getTrialBalanceReport}`, { params: data })
        .then((response) => {
          commit(SET_TRIAL_BALANCE_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_TRIAL_BALANCE_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

